import { Injectable } from '@angular/core';

import { BaseFilterCollapse } from './base-filter-collapse';

@Injectable({
    providedIn: 'root'
})
export class BaseFilterCollapseService {

    /** Abre/Fecha o filtro */
    toggleCollapse(filterCollapseComponent: BaseFilterCollapse) {
        if (!filterCollapseComponent) {
            return;
        }

        filterCollapseComponent.isCollapsedIn = !filterCollapseComponent.isCollapsedIn;
        if (filterCollapseComponent.isCollapsedIn) {
            filterCollapseComponent.open();
        } else {
            filterCollapseComponent.close();
        }
    }

    /** Abre o filtro */
    open(filterCollapseComponent: BaseFilterCollapse) {
        if (!filterCollapseComponent || !filterCollapseComponent.filterCollapse) {
            return;
        }
        // Removendo a animação, por que se tiver um modal dentro do filter-collpase ele não abre corretamento

        // jQuery(filterCollapseComponent.filterCollapse.nativeElement).removeClass('animated').removeClass('fadeOut');
        // jQuery(filterCollapseComponent.filterCollapse.nativeElement).addClass('animated').addClass('fadeIn');
        jQuery(filterCollapseComponent.filterCollapse.nativeElement).slideDown(400);
        filterCollapseComponent.isCollapsedIn = true;
        filterCollapseComponent.collapseIcon = 'fas fa-caret-up';
    }

    /** Fecha o filtro */
    close(filterCollapseComponent: BaseFilterCollapse) {
        if (!filterCollapseComponent || !filterCollapseComponent.filterCollapse) {
            return;
        }

        // jQuery(filterCollapseComponent.filterCollapse.nativeElement).removeClass('animated').removeClass('fadeIn');
        // jQuery(filterCollapseComponent.filterCollapse.nativeElement).addClass('animated').addClass('fadeOut');
        jQuery(filterCollapseComponent.filterCollapse.nativeElement).slideUp(400);
        filterCollapseComponent.isCollapsedIn = false;
        filterCollapseComponent.collapseIcon = 'fas fa-caret-down';
    }

    /** Limpa o filtro */
    clear(filterCollapseComponent: BaseFilterCollapse) {
        if (!filterCollapseComponent) {
            return;
        }

        filterCollapseComponent.filter.clear();
        filterCollapseComponent.isFilterDirty = false;
    }
}
